
      import { createLanguage, createTranslationFile } from '@vocab/webpack/web';
      
    const translations = createTranslationFile({
      "en": createLanguage(
        require.resolveWeak("./translations.json-en-virtual.json!=!../../../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJicmFuZGluZy1zZWN0aW9uLXRpdGxlIjoiQnJhbmRpbmcifQ==!"),
        () => import(
          /* webpackChunkName: "en-translations" */
          "./translations.json-en-virtual.json!=!../../../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJicmFuZGluZy1zZWN0aW9uLXRpdGxlIjoiQnJhbmRpbmcifQ==!"
        )
      ),
"th": createLanguage(
        require.resolveWeak("./translations.json-th-virtual.json!=!../../../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJicmFuZGluZy1zZWN0aW9uLXRpdGxlIjoi4LiB4Liy4Lij4Liq4Lij4LmJ4Liy4LiH4LmB4Lia4Lij4LiZ4LiU4LmMIn0=!"),
        () => import(
          /* webpackChunkName: "th-translations" */
          "./translations.json-th-virtual.json!=!../../../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJicmFuZGluZy1zZWN0aW9uLXRpdGxlIjoi4LiB4Liy4Lij4Liq4Lij4LmJ4Liy4LiH4LmB4Lia4Lij4LiZ4LiU4LmMIn0=!"
        )
      ),
"id": createLanguage(
        require.resolveWeak("./translations.json-id-virtual.json!=!../../../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJicmFuZGluZy1zZWN0aW9uLXRpdGxlIjoiQnJhbmRpbmcifQ==!"),
        () => import(
          /* webpackChunkName: "id-translations" */
          "./translations.json-id-virtual.json!=!../../../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJicmFuZGluZy1zZWN0aW9uLXRpdGxlIjoiQnJhbmRpbmcifQ==!"
        )
      ),
"en-AU": createLanguage(
        require.resolveWeak("./translations.json-en-AU-virtual.json!=!../../../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJicmFuZGluZy1zZWN0aW9uLXRpdGxlIjoiQnJhbmRpbmcifQ==!"),
        () => import(
          /* webpackChunkName: "en-AU-translations" */
          "./translations.json-en-AU-virtual.json!=!../../../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJicmFuZGluZy1zZWN0aW9uLXRpdGxlIjoiQnJhbmRpbmcifQ==!"
        )
      ),
"en-HK": createLanguage(
        require.resolveWeak("./translations.json-en-HK-virtual.json!=!../../../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJicmFuZGluZy1zZWN0aW9uLXRpdGxlIjoiQnJhbmRpbmcifQ==!"),
        () => import(
          /* webpackChunkName: "en-HK-translations" */
          "./translations.json-en-HK-virtual.json!=!../../../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJicmFuZGluZy1zZWN0aW9uLXRpdGxlIjoiQnJhbmRpbmcifQ==!"
        )
      ),
"en-ID": createLanguage(
        require.resolveWeak("./translations.json-en-ID-virtual.json!=!../../../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJicmFuZGluZy1zZWN0aW9uLXRpdGxlIjoiQnJhbmRpbmcifQ==!"),
        () => import(
          /* webpackChunkName: "en-ID-translations" */
          "./translations.json-en-ID-virtual.json!=!../../../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJicmFuZGluZy1zZWN0aW9uLXRpdGxlIjoiQnJhbmRpbmcifQ==!"
        )
      ),
"en-MY": createLanguage(
        require.resolveWeak("./translations.json-en-MY-virtual.json!=!../../../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJicmFuZGluZy1zZWN0aW9uLXRpdGxlIjoiQnJhbmRpbmcifQ==!"),
        () => import(
          /* webpackChunkName: "en-MY-translations" */
          "./translations.json-en-MY-virtual.json!=!../../../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJicmFuZGluZy1zZWN0aW9uLXRpdGxlIjoiQnJhbmRpbmcifQ==!"
        )
      ),
"en-NZ": createLanguage(
        require.resolveWeak("./translations.json-en-NZ-virtual.json!=!../../../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJicmFuZGluZy1zZWN0aW9uLXRpdGxlIjoiQnJhbmRpbmcifQ==!"),
        () => import(
          /* webpackChunkName: "en-NZ-translations" */
          "./translations.json-en-NZ-virtual.json!=!../../../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJicmFuZGluZy1zZWN0aW9uLXRpdGxlIjoiQnJhbmRpbmcifQ==!"
        )
      ),
"en-PH": createLanguage(
        require.resolveWeak("./translations.json-en-PH-virtual.json!=!../../../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJicmFuZGluZy1zZWN0aW9uLXRpdGxlIjoiQnJhbmRpbmcifQ==!"),
        () => import(
          /* webpackChunkName: "en-PH-translations" */
          "./translations.json-en-PH-virtual.json!=!../../../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJicmFuZGluZy1zZWN0aW9uLXRpdGxlIjoiQnJhbmRpbmcifQ==!"
        )
      ),
"en-SG": createLanguage(
        require.resolveWeak("./translations.json-en-SG-virtual.json!=!../../../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJicmFuZGluZy1zZWN0aW9uLXRpdGxlIjoiQnJhbmRpbmcifQ==!"),
        () => import(
          /* webpackChunkName: "en-SG-translations" */
          "./translations.json-en-SG-virtual.json!=!../../../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJicmFuZGluZy1zZWN0aW9uLXRpdGxlIjoiQnJhbmRpbmcifQ==!"
        )
      ),
"en-TH": createLanguage(
        require.resolveWeak("./translations.json-en-TH-virtual.json!=!../../../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJicmFuZGluZy1zZWN0aW9uLXRpdGxlIjoiQnJhbmRpbmcifQ==!"),
        () => import(
          /* webpackChunkName: "en-TH-translations" */
          "./translations.json-en-TH-virtual.json!=!../../../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJicmFuZGluZy1zZWN0aW9uLXRpdGxlIjoiQnJhbmRpbmcifQ==!"
        )
      ),
"th-TH": createLanguage(
        require.resolveWeak("./translations.json-th-TH-virtual.json!=!../../../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJicmFuZGluZy1zZWN0aW9uLXRpdGxlIjoi4LiB4Liy4Lij4Liq4Lij4LmJ4Liy4LiH4LmB4Lia4Lij4LiZ4LiU4LmMIn0=!"),
        () => import(
          /* webpackChunkName: "th-TH-translations" */
          "./translations.json-th-TH-virtual.json!=!../../../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJicmFuZGluZy1zZWN0aW9uLXRpdGxlIjoi4LiB4Liy4Lij4Liq4Lij4LmJ4Liy4LiH4LmB4Lia4Lij4LiZ4LiU4LmMIn0=!"
        )
      ),
"id-ID": createLanguage(
        require.resolveWeak("./translations.json-id-ID-virtual.json!=!../../../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJicmFuZGluZy1zZWN0aW9uLXRpdGxlIjoiQnJhbmRpbmcifQ==!"),
        () => import(
          /* webpackChunkName: "id-ID-translations" */
          "./translations.json-id-ID-virtual.json!=!../../../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJicmFuZGluZy1zZWN0aW9uLXRpdGxlIjoiQnJhbmRpbmcifQ==!"
        )
      ),
"en-PSEUDO": createLanguage(
        require.resolveWeak("./translations.json-en-PSEUDO-virtual.json!=!../../../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJicmFuZGluZy1zZWN0aW9uLXRpdGxlIjoiW+G6nsWZxIPEg8SD4LiB4Li14LmJxozDrMOsw6zguIHguLXguYnEo10ifQ==!"),
        () => import(
          /* webpackChunkName: "en-PSEUDO-translations" */
          "./translations.json-en-PSEUDO-virtual.json!=!../../../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJicmFuZGluZy1zZWN0aW9uLXRpdGxlIjoiW+G6nsWZxIPEg8SD4LiB4Li14LmJxozDrMOsw6zguIHguLXguYnEo10ifQ==!"
        )
      )
      });
  
      export { translations as default };
    